import { render, staticRenderFns } from "./ChargeCodesTabs.vue?vue&type=template&id=5c342750&scoped=true"
import script from "./ChargeCodesTabs.vue?vue&type=script&lang=js"
export * from "./ChargeCodesTabs.vue?vue&type=script&lang=js"
import style0 from "./ChargeCodesTabs.vue?vue&type=style&index=0&id=5c342750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c342750",
  null
  
)

export default component.exports